import { ReactNode } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useNavigate } from 'react-router-dom'
import { GenericSpinner } from '../GenericSpinner/GenericSpinner'
import { Wrapper } from '../../layouts/Wrapper'

interface SecureRouteProps {
    children?: ReactNode
}

export const SecureRoute = ({ children }: SecureRouteProps) => {
  const auth = useAppSelector(state => state.auth)
  const navigate = useNavigate()

  if (auth.pending) {
    return <GenericSpinner />
  }

  if (!auth.data) {
    navigate('/auth/sign-in')
    return <Wrapper />
  }
  
  return children
}